// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PeoplesCostomizeSvg from '@rsuite/icon-font/lib/people/PeoplesCostomize';
var PeoplesCostomize = createSvgIcon({
  as: PeoplesCostomizeSvg,
  ariaLabel: 'peoples costomize',
  category: 'people',
  displayName: 'PeoplesCostomize'
});
export default PeoplesCostomize;